import React, {useEffect, useRef} from "react"
import {isEmpty} from "lodash"
import "./RescueNote.css"

export default function RescueNote(props) {

    const {rescue} = props
    const notesRef = useRef()
    
    const autogrow = (element) => {
        element.style.height = 'inherit';
        element.style.height = `${element.scrollHeight}px`; 
    }
    
    useEffect(() => {
        if (!notesRef.current) return
        autogrow(notesRef.current)
    }, [rescue.rescue.notes])
    
    
    if (rescue.isReadOnly && isEmpty(rescue.rescue.notes)) return

    return <div id="notes-box" className="postit">
        <h3>Beleške</h3>
        <textarea id="notes" ref={notesRef} value={rescue.rescue.notes ?? ''} onChange={rescue.onChange} placeholder="Ovde možete zapisati bilo kakve podatke o povredi, pa ih kasnije sređivati po poljima.&#13;&#10;Ove beleške se ne vide na povrednoj listi." readOnly={rescue.isReadOnly}></textarea>
    </div>
}